import React from "react";
import {useSelector} from "react-redux";
import TabsMenu from "../../components/TabsMenu";
import "./TokenIntermediateScreen.scss";
import tokenImg from "../../images/token.svg";
import BuSpecificHeader from "../../components/Header/BuSpecificHeader";
import {useTranslation} from "react-i18next";

export const TokenIntermediateScreen = () => {
  const {t} = useTranslation();

  const {urlLinkSource, isLoggedInUser} = useSelector((state) => {
    return {
      urlLinkSource: state.globalReducer?.urlLinkSource || null,
      isLoggedInUser: state.customerReducer?.isLoggedInUser,
    };
  });

  return (
    <div className="token-intermediate-screen-container">
      {urlLinkSource === "web" ? <BuSpecificHeader /> : null}
      {isLoggedInUser && <TabsMenu />}
      <div className="is-content-wrap">
        <div className="bg-[#FEFEFF] rounded-[12px] shadow-[0_0_12px_rgba(29,29,29,0.2)] px-4 py-10 text-center w-full max-w-[340px] mx-auto flex flex-col items-center gap-[40px] font-[Lato,sans-serif] min-h-[431px] justify-center">
          <div className="space-y-2 mt-4">
            <p className="text-[#333333] text-[28px] font-bold leading-[100%] text-center font-[Lato,sans-serif]">
              {t("tokenIntermediate.head.text1")}
            </p>
            <p className="text-[#333333] text-[28px] font-bold leading-[100%] text-center font-[Lato,sans-serif]">
              {t("tokenIntermediate.head.text2")}
            </p>
          </div>
          <img src={tokenImg} alt="img" className="w-[200px] h-auto mt-4" />
          <p className="text-[#333333] text-[19px] font-bold leading-[100%] text-center font-[Lato,sans-serif] mt-4">
            {t("tokenIntermediate.foot.text2")}
          </p>
        </div>
      </div>
    </div>
  );
};
